<div class="container" *ngIf="graphList">
  <div class="header">
    <span class="description">
      {{
        'graphs.list.count.description'
          | translate: { count: graphList?.length || 0, max: MAX_GRAPHS }
      }}
    </span>
    <div class="header-actions">
      <app-button
        text="graphs.page.button.create"
        [disable]="!canAddGraphs"
        (onClick)="addGraphClicked()">
      </app-button>
    </div>
  </div>

  <span class="description">
    {{ 'graphs.list.drag-drop.description' | translate }}
  </span>

  <div class="content">
    <div class="content-header">
      <div class="content-header-cell engineer-col">
        {{ 'graphs.list.header.no' | translate }}
      </div>
      <div class="content-header-cell abbreviation-col">
        {{ 'graphs.list.header.name' | translate }}
      </div>
      <div class="content-header-cell address-col">
        {{ 'graphs.list.header.type' | translate }}
      </div>
    </div>

    <div class="empty-groups-container" *ngIf="!graphList || graphList?.length === 0">
      <mat-icon svgIcon="empty-box" class="empty-box-icon" />
      <div class="empty-groups-text">
        {{ 'graphs.list.no-graph.text.1' | translate }}
      </div>
      <div class="empty-groups-text">
        {{ 'graphs.list.no-graph.text.2' | translate }}
      </div>
    </div>

    <div cdkDropList [cdkDropListData]="graphList" (cdkDropListDropped)="graphDrop($event)">
      <div
        *ngFor="let graph of graphList; let i = index"
        class="content-row"
        data-cy="graphs-graph-list-item"
        cdkDrag>
        <div class="content-cell engineer-col" data-cy="graphs-graph-no">
          {{ i + 1 }}
        </div>

        <div class="content-cell abbreviation-col" data-cy="graphs-graph-name">
          {{ graph.title }}
        </div>

        <div class="content-cell address-col" data-cy="graphs-graph-type">
          {{ getGraphTypeName(graph.type) }}
        </div>

        <div class="options content-cell">
          <mat-icon
            class="icon"
            svgIcon="more-options"
            data-cy="graphs-graph-list-item-kebab-icon"
            (click)="toggleOptions(graph.id, $event); $event.stopPropagation()">
          </mat-icon>

          <div class="options-dialog" *ngIf="openOptionsGraphId === graph.id">
            <div
              class="options-item"
              data-cy="graphs-graph-list-item-kebab-menu-edit-button"
              (click)="editGraph(graph); $event.stopPropagation()">
              {{ 'dlg.edit' | translate }}
            </div>

            <div
              class="options-item"
              data-cy="graphs-graph-list-item-kebab-menu-delete-button"
              (click)="deleteGraph(graph); $event.stopPropagation()"
              [class.disabled]="!userCanEdit">
              {{ 'channel.more-option.delete' | translate }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<app-confirmation-window
  #deleteConfirmation
  class="delete-dialog"
  [mainLabel]="'graph.delete.dialog.title'"
  [subLabel]="'graph.delete.dialog.subLabel'"
  [discardLabel]="'graph.delete.dialog.cancel'"
  [saveLabel]="'graph.delete.dialog.continue'"
  [allButtonsLeft]="true"
  [inverseColors]="true"
  [title]="deleteGraphTitle">
</app-confirmation-window>
